import { render, staticRenderFns } from "./AboutSenateControl.vue?vue&type=template&id=4c613d6d&"
import script from "./AboutSenateControl.vue?vue&type=script&lang=js&"
export * from "./AboutSenateControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports